import { Dialog as Dialog$1, Box, PageHeader as PageHeader$1, sx } from '@primer/react';
import React, { forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';

const DialogImpl = /*#__PURE__*/forwardRef(function Dialog(props, ref) {
  // @ts-expect-error - PrimerDialog is not recognized as a valid component type
  return /*#__PURE__*/jsx(Box, {
    as: Dialog$1,
    ref: ref,
    ...props
  });
});
const DialogHeader = /*#__PURE__*/forwardRef(function DialogHeader(props, ref) {
  return /*#__PURE__*/jsx(Box, {
    as: Dialog$1.Header,
    ref: ref,
    ...props
  });
});
const DialogBody = /*#__PURE__*/forwardRef(function DialogBody(props, ref) {
  // @ts-expect-error - PrimerDialog.Body is not recognized as a valid component type
  return /*#__PURE__*/jsx(Box, {
    as: Dialog$1.Body,
    ref: ref,
    ...props
  });
});
const DialogFooter = /*#__PURE__*/forwardRef(function DialogFooter(props, ref) {
  return /*#__PURE__*/jsx(Box, {
    as: Dialog$1.Footer,
    ref: ref,
    ...props
  });
});
const Dialog = Object.assign(DialogImpl, {
  Buttons: Dialog$1.Buttons,
  Header: DialogHeader,
  Body: DialogBody,
  Footer: DialogFooter
});

const StyledPageHeader = styled(PageHeader$1).withConfig({
  shouldForwardProp: prop => prop !== 'sx'
}).withConfig({
  displayName: "PageHeader__StyledPageHeader",
  componentId: "sc-1g9symn-0"
})(["", ""], sx);
const PageHeaderImpl = /*#__PURE__*/React.forwardRef(({
  as,
  ...props
}, ref) => /*#__PURE__*/jsx(StyledPageHeader, {
  ...props,
  ...(as ? {
    forwardedAs: as
  } : {}),
  ref: ref
}));
function PageHeaderActions({
  sx,
  ...rest
}) {
  const style = {};
  if (sx) {
    // @ts-ignore sx has height attribute
    const {
      height
    } = sx;
    if (height) {
      style['--custom-height'] = height;
    }
  }

  // @ts-expect-error type mismatch between Box usage here and PrimerPageHeader.Actions
  return /*#__PURE__*/jsx(Box, {
    ...rest,
    as: PageHeader$1.Actions,
    style: style,
    sx: sx
  });
}
function StyledPageHeaderTitle({
  sx,
  ...rest
}) {
  const style = {};
  if (sx) {
    // @ts-ignore sx can have color attribute
    const {
      fontSize,
      lineHeight,
      fontWeight
    } = sx;
    if (fontSize) {
      style['--custom-font-size'] = fontSize;
    }
    if (lineHeight) {
      style['--custom-line-height'] = lineHeight;
    }
    if (fontWeight) {
      style['--custom-font-weight'] = fontWeight;
    }
  }

  // @ts-expect-error type mismatch between Box usage here and PrimerPageHeader.Title
  return /*#__PURE__*/jsx(Box, {
    ...rest,
    as: PageHeader$1.Title,
    style: style,
    sx: sx
  });
}
const PageHeaderTitle = ({
  as,
  ...props
}) => /*#__PURE__*/jsx(StyledPageHeaderTitle, {
  ...props,
  ...(as ? {
    forwardedAs: as
  } : {})
});
const PageHeaderTitleArea = styled(PageHeader$1.TitleArea).withConfig({
  shouldForwardProp: prop => prop !== 'sx'
}).withConfig({
  displayName: "PageHeader__PageHeaderTitleArea",
  componentId: "sc-1g9symn-1"
})(["", ""], sx);
const PageHeader = Object.assign(PageHeaderImpl, {
  Actions: PageHeaderActions,
  ContextArea: PageHeader$1.ContextArea,
  ParentLink: PageHeader$1.ParentLink,
  ContextBar: PageHeader$1.ContextBar,
  TitleArea: PageHeaderTitleArea,
  ContextAreaActions: PageHeader$1.ContextAreaActions,
  LeadingAction: PageHeader$1.LeadingAction,
  Breadcrumbs: PageHeader$1.Breadcrumbs,
  LeadingVisual: PageHeader$1.LeadingVisual,
  Title: PageHeaderTitle,
  TrailingVisual: PageHeader$1.TrailingVisual,
  Description: PageHeader$1.Description,
  TrailingAction: PageHeader$1.TrailingAction
});

export { Dialog as D, PageHeader as P };
